import { render, staticRenderFns } from "./LocalePriority.vue?vue&type=template&id=1224673a&scoped=true"
import script from "./LocalePriority.vue?vue&type=script&lang=js"
export * from "./LocalePriority.vue?vue&type=script&lang=js"
import style0 from "./LocalePriority.vue?vue&type=style&index=0&id=1224673a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1224673a",
  null
  
)

export default component.exports